<template>
 <div class="page-analytics">
 <el-row :gutter="20" class="card-row">
 <el-col :span="8">
 <div class="stat-card blue">
 <div class="stat-card-top">
 <div class="stat-card-icon"><i class="el-icon-data-analysis"></i></div>
 <div class="stat-card-info">
 <div class="stat-card-value">{{ bounceRate }}%</div>
 <div class="stat-card-label">跳出率</div>
 </div>
 </div>
 <div class="stat-card-sub">{{ bounceVisitors }} / {{ totalVisitors }} 访客跳出</div>
 </div>
 </el-col>
 <el-col :span="8">
 <div class="stat-card green">
 <div class="stat-card-top">
 <div class="stat-card-icon"><i class="el-icon-user"></i></div>
 <div class="stat-card-info">
 <div class="stat-card-value">{{ totalVisitors }}</div>
 <div class="stat-card-label">总访客数</div>
 </div>
 </div>
 <div class="stat-card-sub">所选时间范围内独立访客</div>
 </div>
 </el-col>
 <el-col :span="8">
 <div class="stat-card orange">
 <div class="stat-card-top">
 <div class="stat-card-icon"><i class="el-icon-document-remove"></i></div>
 <div class="stat-card-info">
 <div class="stat-card-value">{{ bounceVisitors }}</div>
 <div class="stat-card-label">跳出访客</div>
 </div>
 </div>
 <div class="stat-card-sub">仅访问一个页面即离开</div>
 </div>
 </el-col>
 </el-row>

 <el-row :gutter="20" class="card-row">
 <el-col :span="24">
 <div class="chart-card">
 <div class="chart-header">
 <el-date-picker
 v-model="dateRange"
 type="daterange"
 range-separator="至"
 start-placeholder="开始日期"
 end-placeholder="结束日期"
 value-format="yyyy-MM-dd"
 :picker-options="pickerOptions"
 @change="loadAll"
 />
 <el-select v-model="websiteId" placeholder="全部网站" clearable size="small" style="width:180px; margin-left:12px" @change="loadAll">
 <el-option label="全部网站" :value="0" />
 <el-option v-for="w in websites" :key="w.id" :label="w.name" :value="w.id" />
 </el-select>
 <el-button type="primary" size="small" @click="loadAll" style="margin-left:12px">刷新</el-button>
 </div>
 <div ref="topPagesChart" class="chart-body"></div>
 </div>
 </el-col>
 </el-row>

 <el-row :gutter="20" class="card-row">
 <el-col :span="12">
 <div class="chart-card">
 <div class="chart-header"><span class="chart-title">入口页分析</span></div>
 <el-table :data="entryPages" stripe style="width:100%" size="small">
 <el-table-column type="index" label="#" width="50" />
 <el-table-column label="页面" show-overflow-tooltip>
 <template slot-scope="{ row }">
 <span class="page-url">{{ formatUrl(row.page_path) }}</span>
 </template>
 </el-table-column>
 <el-table-column prop="entry_count" label="进入次数" width="90" align="right" sortable />
 </el-table>
 </div>
 </el-col>
 <el-col :span="12">
 <div class="chart-card">
 <div class="chart-header"><span class="chart-title">出口页分析</span></div>
 <el-table :data="exitPages" stripe style="width:100%" size="small">
 <el-table-column type="index" label="#" width="50" />
 <el-table-column label="页面" show-overflow-tooltip>
 <template slot-scope="{ row }">
 <span class="page-url">{{ formatUrl(row.page_path) }}</span>
 </template>
 </el-table-column>
 <el-table-column prop="exit_count" label="离开次数" width="90" align="right" sortable />
 </el-table>
 </div>
 </el-col>
 </el-row>
 </div>
</template>

<script>
import * as echarts from 'echarts';
import { statsApi, websiteApi } from '../api';
import dayjs from 'dayjs';

export default {
 name: 'PageAnalytics',
 data() {
 return {
 dateRange: [dayjs().subtract(30, 'day').format('YYYY-MM-DD'), dayjs().format('YYYY-MM-DD')],
 websiteId: 0,
 websites: [],
 bounceRate: 0,
 totalVisitors: 0,
 bounceVisitors: 0,
 topPages: [],
 entryPages: [],
 exitPages: [],
 charts: {},
 pickerOptions: {
 shortcuts: [
 { text: '今天', onClick(picker) { const d = dayjs().format('YYYY-MM-DD'); picker.$emit('pick', [d, d]); } },
 { text: '近7天', onClick(picker) { picker.$emit('pick', [dayjs().subtract(6, 'day').format('YYYY-MM-DD'), dayjs().format('YYYY-MM-DD')]); } },
 { text: '近30天', onClick(picker) { picker.$emit('pick', [dayjs().subtract(29, 'day').format('YYYY-MM-DD'), dayjs().format('YYYY-MM-DD')]); } },
 { text: '本月', onClick(picker) { picker.$emit('pick', [dayjs().startOf('month').format('YYYY-MM-DD'), dayjs().format('YYYY-MM-DD')]); } },
 ]
 }
 };
 },
 mounted() {
 this.loadWebsites();
 this.loadAll();
 window.addEventListener('resize', this.resizeCharts);
 },
 beforeDestroy() {
 window.removeEventListener('resize', this.resizeCharts);
 Object.values(this.charts).forEach(c => c && c.dispose());
 },
 methods: {
 async loadWebsites() {
 try {
 const res = await websiteApi.list({ page: 1, page_size: 100 });
 if (res.code === 0) this.websites = res.data.list;
 } catch (e) { console.error(e); }
 },
 async loadAll() {
 const [startDate, endDate] = this.dateRange || [];
 const params = { start_date: startDate, end_date: endDate, website_id: this.websiteId };
 this.loadPageAnalytics(params);
 },
 async loadPageAnalytics(params) {
 try {
 const res = await statsApi.pageAnalytics(params);
 if (res.code !== 0) return;
 const d = res.data;
 this.bounceRate = d.bounce_rate;
 this.totalVisitors = d.total_visitors;
 this.bounceVisitors = d.bounce_visitors;
 this.topPages = d.top_pages;
 this.entryPages = d.entry_pages;
 this.exitPages = d.exit_pages;
 this.renderTopPagesChart();
 } catch (e) { console.error(e); }
 },
 renderTopPagesChart() {
 const data = this.topPages;
 const names = data.map(d => this.formatUrl(d.page_path, true));
 const visits = data.map(d => +d.visit_count);
 const visitors = data.map(d => +d.visitor_count);
 this.$nextTick(() => {
 const el = this.$refs.topPagesChart;
 if (!el) return;
 if (this.charts.topPages) this.charts.topPages.dispose();
 this.charts.topPages = echarts.init(el);
 this.charts.topPages.setOption({
 tooltip: { trigger: 'axis', axisPointer: { type: 'shadow' }, backgroundColor: 'rgba(30,41,59,0.92)', borderColor: 'rgba(91,141,239,0.15)', textStyle: { color: '#fff', fontSize: 12 } },
 legend: { data: ['访问量', '独立访客'], top: 5, textStyle: { fontSize: 12 } },
 grid: { left: 60, right: 30, top: 55, bottom: 70 },
 xAxis: { type: 'category', data: names, axisLabel: { fontSize: 11, color: '#64748b', interval: 0, rotate: 30, formatter: v => v.length > 20 ? v.slice(0, 20) + '...' : v }, axisLine: { lineStyle: { color: '#cbd5e1' } } },
 yAxis: { type: 'value', axisLabel: { color: '#64748b' }, splitLine: { lineStyle: { color: '#f1f3f5' } } },
 dataZoom: [{ type: 'inside' }, { type: 'slider', height: 20, bottom: 10, borderColor: '#e2e8f0', fillerColor: 'rgba(91,141,239,0.06)' }],
 series: [
 { name: '访问量', type: 'bar', data: visits, barMaxWidth: 40, itemStyle: { color: new echarts.graphic.LinearGradient(0,0,0,1,[{offset:0,color:'#5b8def'},{offset:1,color:'rgba(91,141,239,0.15)'}]), borderRadius: [4,4,0,0] } },
 { name: '独立访客', type: 'bar', data: visitors, barMaxWidth: 40, itemStyle: { color: new echarts.graphic.LinearGradient(0,0,0,1,[{offset:0,color:'#6b9e72'},{offset:1,color:'rgba(107,158,114,0.15)'}]), borderRadius: [4,4,0,0] } },
 ]
 });
 });
 },
 formatUrl(url, short) {
 if (!url) return '-';
 try {
 const u = new URL(url);
 if (short) return (u.pathname === '/' ? u.host : u.pathname).slice(0, 30);
 return u.pathname === '/' ? u.origin + '/' : u.pathname;
 } catch {
 return url.length > 50 ? '...' + url.slice(-47) : url;
 }
 },
 resizeCharts() {
 Object.values(this.charts).forEach(c => c && c.resize());
 },
 }
};
</script>

<style scoped>
.filter-bar { display: flex; align-items: center; margin-bottom: 18px; }
.card-row { margin-bottom: 18px; }
.card-row > .el-col { display: flex; }

.stat-card {
 background: #fff; border-radius: 8px; padding: 20px 22px;
 box-shadow: 0 1px 3px rgba(0,0,0,0.04); border: 1px solid #eef0f3;
 width: 100%; display: flex; flex-direction: column;
 border-left: 3px solid #e2e8f0; transition: box-shadow 0.2s;
}
.stat-card:hover { box-shadow: 0 4px 12px rgba(0,0,0,0.06); }
.stat-card.blue { border-left-color: #5b8def; }
.stat-card.green { border-left-color: #6b9e72; }
.stat-card.orange { border-left-color: #d4905a; }
.stat-card-top { display: flex; align-items: center; gap: 14px; }
.stat-card-icon { width: 40px; height: 40px; border-radius: 8px; display: flex; align-items: center; justify-content: center; font-size: 20px; flex-shrink: 0; }
.stat-card.blue .stat-card-icon { background: rgba(91,141,239,0.08); color: #5b8def; }
.stat-card.green .stat-card-icon { background: rgba(107,158,114,0.08); color: #6b9e72; }
.stat-card.orange .stat-card-icon { background: rgba(212,144,90,0.08); color: #d4905a; }
.stat-card-info { flex: 1; }
.stat-card-value { font-size: 26px; font-weight: 600; color: #1e293b; line-height: 1.3; }
.stat-card-label { font-size: 13px; color: #64748b; margin-top: 2px; }
.stat-card-sub { font-size: 12px; color: #94a3b8; margin-top: auto; padding-top: 10px; border-top: 1px solid #f5f6f8; min-height: 20px; }

.chart-card { background: #fff; border-radius: 8px; box-shadow: 0 1px 3px rgba(0,0,0,0.04); border: 1px solid #eef0f3; overflow: hidden; width: 100%; }
.chart-header { padding: 14px 20px; border-bottom: 1px solid #f0f1f3; display: flex; align-items: center; justify-content: space-between; }
.chart-title { font-size: 14px; font-weight: 600; color: #1e293b; }
.chart-body { height: 340px; padding: 12px; }
.page-url { font-size: 12px; color: #475569; word-break: break-all; }
</style>
